import React from "react";
import AdminPage from "../components/AdminPage/AdminPage";

const Admin = () => {
  return <div>
    <AdminPage/>
  </div>;
};

export default Admin;
